var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCollaboration(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2,0,0,2,0,0)"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:inherit;stroke-linecap:round;stroke-linejoin:round;}")), /*#__PURE__*/React.createElement("circle", {
    cx: 3.183,
    cy: 17.118,
    r: 2.683
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.415,23.361A4.6,4.6,0,0,0,.5,21.432"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20.817,
    cy: 17.118,
    r: 2.683
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.585,23.361A4.6,4.6,0,0,1,23.5,21.432"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 16.351,
    r: 3.45
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.585,23.361a6.2,6.2,0,0,0-9.17,0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 7.539,
    r: 1.533
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.046,11.289l-1.506.349a1.368,1.368,0,0,1-1.3-2.267L7.291,8.235a1.025,1.025,0,0,0,0-1.393L6.238,5.707a1.369,1.369,0,0,1,1.3-2.268l1.506.349a1.016,1.016,0,0,0,1.2-.7L10.7,1.607a1.36,1.36,0,0,1,2.605,0l.452,1.485a1.016,1.016,0,0,0,1.2.7l1.5-.349a1.369,1.369,0,0,1,1.3,2.268L16.708,6.842a1.027,1.027,0,0,0,0,1.393l1.054,1.136a1.368,1.368,0,0,1-1.3,2.267l-1.5-.349"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.3,14.2a8.68,8.68,0,0,0,6.149,2.148"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.076,15.462a6.807,6.807,0,0,0,4.791,1.656"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.709,15.462A6.807,6.807,0,0,0,23.5,17.118"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollaboration);
export default __webpack_public_path__ + "static/media/collaboration.dcdefbc5.svg";
export { ForwardRef as ReactComponent };